document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initScramble();
  initMarquee();
  initOfferCountdown();
  initSlideshows();
});

function initSlideshows() {
  document.querySelectorAll('[data-fz-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-fz-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-fz-dot]');
    var playBtn = root.querySelector('[data-fz-playpause]');
    var iconPause = root.querySelector('[data-fz-icon-pause]');
    var iconPlay = root.querySelector('[data-fz-icon-play]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var playing = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var current = 0;
    var timer = null;

    function resetDotProgress() {
      dots.forEach(function (dot) { dot.classList.remove('fz-slideshow__dot--progress'); });
    }
    function startDotProgress() {
      resetDotProgress();
      var dot = dots[current];
      if (!dot) return;
      // Force reflow so the CSS animation restarts from 0 even if this same
      // class was just removed from this element a moment ago.
      void dot.offsetWidth;
      dot.classList.add('fz-slideshow__dot--progress');
    }
    function goTo(index) {
      slides[current].classList.remove('fz-slide--active');
      dots[current] && dots[current].classList.remove('fz-slideshow__dot--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('fz-slide--active');
      dots[current] && dots[current].classList.add('fz-slideshow__dot--active');
      if (playing) startDotProgress(); else resetDotProgress();
    }
    function next() { goTo(current + 1); }
    function start() {
      stop();
      timer = setInterval(next, interval);
      startDotProgress();
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
      resetDotProgress();
    }
    function setPlaying(state) {
      playing = state;
      if (playing) { start(); } else { stop(); }
      if (iconPause && iconPlay) {
        iconPause.style.display = playing ? '' : 'none';
        iconPlay.style.display = playing ? 'none' : '';
      }
      if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pausar presentación' : 'Reanudar presentación');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        setPlaying(false);
      });
    });
    if (playBtn) {
      playBtn.addEventListener('click', function () { setPlaying(!playing); });
    }

    setPlaying(playing);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.fz-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('fz-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-fz-delay') || 0;
          setTimeout(function () { entry.target.classList.add('fz-visible'); }, Number(delay));
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('.fz-countup');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target') || el.textContent);
        if (isNaN(target)) return;
        if (reduce) { el.textContent = formatCount(target, el); return; }
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = formatCount(target * eased, el);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function formatCount(value, el) {
  var decimals = Number(el.getAttribute('data-decimals') || 0);
  return value.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function initScramble() {
  var els = document.querySelectorAll('.fz-scramble');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pool = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var final = el.textContent.trim();
        if (reduce || !final) { el.textContent = final; return; }
        var duration = 900;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var revealCount = Math.floor(progress * final.length);
          var out = '';
          for (var i = 0; i < final.length; i++) {
            var ch = final[i];
            if (ch === ' ' || i < revealCount) { out += ch; }
            else { out += pool[Math.floor(Math.random() * pool.length)]; }
          }
          el.textContent = out;
          if (progress < 1) { requestAnimationFrame(step); }
          else { el.textContent = final; }
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('.fz-marquee').forEach(function (wrap) {
    var track = wrap.querySelector('.fz-marquee__track');
    if (!track || track.dataset.fzDup) return;
    track.dataset.fzDup = '1';
    track.innerHTML += track.innerHTML;
    var speed = Number(wrap.getAttribute('data-speed') || 40);
    track.style.animationDuration = speed + 's';
  });
}

function initOfferCountdown() {
  document.querySelectorAll('[data-fz-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-fz-countdown')).getTime();
    if (isNaN(target)) return;
    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        el.textContent = '00:00:00:00';
        return;
      }
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var m = Math.floor((diff / (1000 * 60)) % 60);
      var s = Math.floor((diff / 1000) % 60);
      el.textContent = pad(d) + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    tick();
    setInterval(tick, 1000);
  });
}
